import React from "react";
import {
    Box,
    Divider,
    Grid,
    TextInput,
    Text,
    Group,
    Button,
    Accordion,
    Switch,
    NumberInput,
    Select,
} from "@mantine/core";
import type { IFormularioEquipoVistaProps } from "../interfaces";
import { IconDeviceFloppy, IconPencilCheck } from "@tabler/icons-react";
import { EnumTipoEquipo } from "../enums/enumTipoEquipo";

const FormularioEquipoVista: React.FunctionComponent<IFormularioEquipoVistaProps> = ({
    equipoSeleccionado,
    manejarCambioValorEquipo,
    agregarEditarEquipo,
    entidadesEquipo,
    agregarError,
    errores
}) => {

    return (
        <Box p="md" >
            <Grid gutter="md">
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <TextInput
                        label="Código Equipo"
                        placeholder="Código Equipo"
                        name="CodigoEquipo"
                        size="xs"
                        maxLength={50}
                        value={equipoSeleccionado.Codigo || ""}
                        onChange={(event) => {
                            manejarCambioValorEquipo("Codigo", event.currentTarget.value)
                            if (event.target.value === '') {
                                agregarError('Codigo', 'Este campo es requerido')
                            }
                            else {
                                agregarError('Codigo', '')
                            }
                        }}
                        error={errores.Codigo}
                        required
                    />
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 3 }}>
                    <TextInput
                        label="Nombre"
                        placeholder="Nombre"
                        name="Nombre"
                        size="xs"
                        maxLength={50}
                        value={equipoSeleccionado.Nombre || ""}
                        onChange={(event) => {
                            manejarCambioValorEquipo("Nombre", event.currentTarget.value)
                            if (event.target.value === '') {
                                agregarError('Nombre', 'Este campo es requerido')
                            }
                            else {
                                agregarError('Nombre', '')
                            }
                        }}
                        error={errores.Nombre}
                        required
                    />
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        label="Tipo Equipo"
                        placeholder="Tipo Equipo"
                        size="xs"
                        required
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesEquipo.TiposEquipo.map(tp => ({
                            value: tp.Id.toString(),
                            label: tp.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron tipos"
                        value={equipoSeleccionado.TipoEquipoId ? equipoSeleccionado.TipoEquipoId.toString() : null}
                        onChange={(value) => {
                            manejarCambioValorEquipo("TipoEquipoId", value ? Number(value) : 0)
                            if (value === null) {
                                agregarError('TipoEquipoId', 'Selecciona un tipo de equipo')
                            }
                            else {
                                agregarError('TipoEquipoId', '')
                            }
                        }}
                        error={errores.TipoEquipoId}
                    />
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        label="Marca"
                        placeholder="Marca"
                        searchable
                        size="xs"
                        required
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesEquipo.MarcasEquipo.map(tp => ({
                            value: tp.Id.toString(),
                            label: tp.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron marcas"
                        value={equipoSeleccionado.MarcaId ? equipoSeleccionado.MarcaId.toString() : null}
                        onChange={(value) => {
                            manejarCambioValorEquipo("MarcaId", value ? Number(value) : 0)
                            if (value === null) {
                                agregarError('MarcaId', 'Selecciona una marca')
                            }
                            else {
                                agregarError('MarcaId', '')
                            }
                        }}
                        error={errores.MarcaId}
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        label="Modelo"
                        placeholder="Modelo"
                        searchable
                        size="xs"
                        disabled={equipoSeleccionado.MarcaId === 0}
                        required
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesEquipo.ModelosEquipoFiltrados.map(tp => ({
                            value: tp.Id.toString(),
                            label: tp.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron modelos"
                        value={equipoSeleccionado.ModeloId ? equipoSeleccionado.ModeloId.toString() : null}
                        onChange={(value) => {
                            manejarCambioValorEquipo("ModeloId", value ? Number(value) : 0)
                            if (value === null) {
                                agregarError('ModeloId', 'Selecciona un modelo')
                            }
                            else {
                                agregarError('ModeloId', '')
                            }
                        }}
                        error={errores.ModeloId}
                    />
                </Grid.Col>
                <Grid.Col mt={'1.5em'} span={{ base: 12, md: 2 }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Switch
                        style={{ cursor: 'pointer' }}
                        label="Adoptado"
                        labelPosition="left"
                        checked={equipoSeleccionado.Adoptado}
                        onChange={(event) => manejarCambioValorEquipo("Adoptado", event.target.checked)}
                    />
                </Grid.Col>
                {equipoSeleccionado.TipoEquipoId !== 0 && equipoSeleccionado.TipoEquipoId && equipoSeleccionado.TipoEquipoId === EnumTipoEquipo.Ascensor ? (
                    <>
                        <Grid.Col span={{ base: 12, md: 1 }}>
                            <NumberInput
                                size="xs"
                                min={1}
                                required
                                label='Pisos'
                                value={equipoSeleccionado.Pisos}
                                onChange={(value) => {
                                    manejarCambioValorEquipo("Pisos", value ? value : 0)
                                    if (value === 0) {
                                        agregarError('Pisos', 'Este campo es requerido')
                                    }
                                    else {
                                        agregarError('Pisos', '')
                                    }
                                }}
                                error={errores.Pisos}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, md: 1 }}>
                            <NumberInput
                                size="xs"
                                min={1}
                                required
                                label='Paradas'
                                value={equipoSeleccionado.Paradas}
                                onChange={(value) => {
                                    manejarCambioValorEquipo("Paradas", value ? value : 0)
                                    if (value === 0) {
                                        agregarError('Paradas', 'Este campo es requerido')
                                    }
                                    else {
                                        agregarError('Paradas', '')
                                    }
                                }}
                                error={errores.Paradas}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, md: 1 }}>
                            <NumberInput
                                size="xs"
                                min={1}
                                required
                                label='Entradas'
                                value={equipoSeleccionado.Entradas}
                                onChange={(value) => {
                                    manejarCambioValorEquipo("Entradas", value ? value : 0)
                                    if (value === 0) {
                                        agregarError('Entradas', 'Este campo es requerido')
                                    }
                                    else {
                                        agregarError('Entradas', '')
                                    }
                                }}
                                error={errores.Entradas}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, md: 1 }}>
                            <NumberInput
                                size="xs"
                                min={0}
                                required
                                label='Capacidad'
                                value={equipoSeleccionado.Capacidad}
                                onChange={(value) => {
                                    manejarCambioValorEquipo("Capacidad", value ? value : 0)
                                    if (value === 0) {
                                        agregarError('Capacidad', 'Este campo es requerido')
                                    }
                                    else {
                                        agregarError('Capacidad', '')
                                    }
                                }}
                                error={errores.Capacidad}
                            />
                        </Grid.Col>
                    </>
                ) : (
                    equipoSeleccionado.TipoEquipoId ?
                        <>
                            <Grid.Col span={{ base: 12, md: 1 }}>
                                <NumberInput
                                    size="xs"
                                    min={0}
                                    required
                                    label='Angulo'
                                    value={equipoSeleccionado.Angulo}
                                    onChange={(value) => {
                                        manejarCambioValorEquipo("Angulo", value ? value : 0)
                                        if (value === 0) {
                                            agregarError('Angulo', 'Este campo es requerido')
                                        }
                                        else {
                                            agregarError('Angulo', '')
                                        }
                                    }}
                                    error={errores.Angulo}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 1 }}>
                                <NumberInput
                                    size="xs"
                                    min={0}
                                    required
                                    label='Altura'
                                    value={equipoSeleccionado.Altura}
                                    onChange={(value) => {
                                        manejarCambioValorEquipo("Altura", value ? value : 0)
                                        if (value === 0) {
                                            agregarError('Altura', 'Este campo es requerido')
                                        }
                                        else {
                                            agregarError('Altura', '')
                                        }
                                    }}
                                    error={errores.Altura}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 2 }}>
                                <NumberInput
                                    size="xs"
                                    min={0}
                                    required
                                    label='Ancho de paso'
                                    value={equipoSeleccionado.Ancho}
                                    onChange={(value) => {
                                        manejarCambioValorEquipo("Ancho", value ? value : 0)
                                        if (value === 0) {
                                            agregarError('Ancho', 'Este campo es requerido')
                                        }
                                        else {
                                            agregarError('Ancho', '')
                                        }
                                    }}
                                    error={errores.Ancho}
                                />
                            </Grid.Col>
                        </> : (<></>)
                )}

                <Grid.Col span={{ base: 12, md: 1 }}>
                    <NumberInput
                        size="xs"
                        min={0}
                        required
                        label='Velocidad'
                        value={equipoSeleccionado.Velocidad}
                        onChange={(value) => {
                            manejarCambioValorEquipo("Velocidad", value ? value : 0)
                            if (value === 0) {
                                agregarError('Velocidad', 'Este campo es requerido')
                            }
                            else {
                                agregarError('Velocidad', '')
                            }
                        }}
                        error={errores.Velocidad}
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 2 }}>
                    <Select
                        label="Estado"
                        placeholder="Estado"
                        searchable
                        size="xs"
                        required
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesEquipo.EstadosEquipo.map(tp => ({
                            value: tp.Id.toString(),
                            label: tp.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron estados"
                        value={equipoSeleccionado.EstadoEquipoId ? equipoSeleccionado.EstadoEquipoId.toString() : null}
                        onChange={(value) => {
                            manejarCambioValorEquipo("EstadoEquipoId", value ? Number(value) : 0)
                            if (value === null) {
                                agregarError('EstadoEquipoId', 'Selecciona un estado')
                            }
                            else {
                                agregarError('EstadoEquipoId', '')
                            }
                        }}
                        error={errores.EstadoEquipoId}
                    />
                </Grid.Col>
            </Grid>

            <Divider style={{display: 'none'}} my="md" />

            <Accordion style={{display: 'none'}} __size="xs" variant="contained" radius="md">
                <Accordion.Item value="Taxonomia">
                    <Accordion.Control>
                        <Text fw={600} fz="sm">Taxonomia</Text>
                    </Accordion.Control>
                    <Accordion.Panel bg="#fff" p={8}>
                        <Grid gutter="xl">
                            {/* <Grid.Col span={6}>
                                <Grid gutter="md">
                                    <Text fw={600} fz={13} mt="xs">
                                        Contacto 1
                                    </Text>
                                    <Grid.Col span={{ base: 12, md: 12 }}>
                                        <TextInput
                                            label="Nombre Contacto"
                                            placeholder="Nombre Contacto"
                                            name="NombreContacto1"
                                            size="xs"
                                            value={equipoSeleccionado.NombreContacto1 || ""}
                                            onChange={(event) =>
                                                manejarCambioValorEquipo(
                                                    "NombreContacto1",
                                                    event.currentTarget.value
                                                )
                                            }
                                            required
                                        />
                                    </Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 6 }}>
                                        <TextInput
                                            label="Telefono Contacto"
                                            placeholder="Telefono Contacto"
                                            name="TelefonoContacto1"
                                            size="xs"
                                            value={equipoSeleccionado.TelefonoContacto1 || ""}
                                            onChange={(event) =>
                                                manejarCambioValorEquipo(
                                                    "TelefonoContacto1",
                                                    event.currentTarget.value
                                                )
                                            }
                                            required
                                        />
                                    </Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 6 }}>
                                        <TextInput
                                            label="Correo Contacto"
                                            placeholder="Correo Contacto"
                                            name="CorreoContacto1"
                                            size="xs"
                                            value={equipoSeleccionado.EmailContacto1 || ""}
                                            onChange={(event) =>
                                                manejarCambioValorEquipo(
                                                    "EmailContacto1",
                                                    event.currentTarget.value
                                                )
                                            }
                                            required
                                        />
                                    </Grid.Col>
                                </Grid>
                            </Grid.Col>

                            <Grid.Col span={6}>
                                <Grid gutter="md">
                                    <Text fw={600} mt="xs" fz={13}>
                                        Contacto 2
                                    </Text>
                                    <Grid.Col span={{ base: 12, md: 12 }}>
                                        <TextInput
                                            label="Nombre Contacto 2"
                                            placeholder="Nombre Contacto 2"
                                            name="NombreContacto2"
                                            size="xs"
                                            value={equipoSeleccionado.NombreContacto2 || ""}
                                            onChange={(event) =>
                                                manejarCambioValorEquipo(
                                                    "NombreContacto2",
                                                    event.currentTarget.value
                                                )
                                            }
                                            required
                                        />
                                    </Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 6 }}>
                                        <TextInput
                                            label="Telefono Contacto 2"
                                            placeholder="Telefono Contacto 2"
                                            name="TelefonoContacto2"
                                            size="xs"
                                            value={equipoSeleccionado.TelefonoContacto2 || ""}
                                            onChange={(event) =>
                                                manejarCambioValorEquipo(
                                                    "TelefonoContacto2",
                                                    event.currentTarget.value
                                                )
                                            }
                                            required
                                        />
                                    </Grid.Col>

                                    <Grid.Col span={{ base: 12, md: 6 }}>
                                        <TextInput
                                            label="Correo Contacto 2"
                                            placeholder="Correo Contacto 2"
                                            name="CorreoContacto2"
                                            size="xs"
                                            value={equipoSeleccionado.EmailContacto2 || ""}
                                            onChange={(event) =>
                                                manejarCambioValorEquipo(
                                                    "EmailContacto2",
                                                    event.currentTarget.value
                                                )
                                            }
                                            required
                                        />
                                    </Grid.Col>
                                </Grid>
                            </Grid.Col> */}
                        </Grid>
                    </Accordion.Panel>
                </Accordion.Item>
            </Accordion>

            <Box pos="sticky" bottom={0} bg="white">
                <Group justify="flex-end" pt="sm">
                    <Button
                        color="primary"
                        onClick={agregarEditarEquipo}
                        variant="filled"
                        size='compact-sm'
                        rightSection={equipoSeleccionado.Id ? <IconPencilCheck opacity={100} color="white" size={15} /> : <IconDeviceFloppy opacity={100} color="white" size={15} />}
                        radius="lg"
                    >
                        <Text fw={500} fz={11}>{equipoSeleccionado.Id ? "Editar Equipo" : "Guardar Equipo"}</Text>
                    </Button>
                </Group>
            </Box>
        </Box>
    );
};

export default FormularioEquipoVista;
